import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/login/password-reset/page.tsx");
